import React, { useEffect, useState } from 'react';
import "./Deeplink.css"
import openIC from "./image/open.svg"
import apple from "./image/apple.svg"
import google from "./image/playstore.svg"

import QRIC from "./image/qr.svg"
import logo from "./image/logo.svg"
import { useLocation } from 'react-router';

const RewardsTickPageApp = () => {

  const openAppStore = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app';
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = 'https://apps.apple.com/app/id6751297042';
    } else {
      window.location.href = window.location.origin;
    }
  };

  useEffect(() => {

    const fallback = {
      android: 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app',
      ios: `https://apps.apple.com/app/id6751297042`,
      web: `${window.location.origin}/rewardstick`,
    };

    const userAgent = navigator.userAgent || navigator.vendor;
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPad|iPhone|iPod/.test(userAgent);

    if (isAndroid) {
      window.location.href = fallback.android;

    } else if (isIOS) {
      window.location.href = fallback.ios;
    }
  }, []);
  return (
    <div className='Deeplink'>
      <div className='Deeplink-logo-style-wrapper' >
        <img alt='' src={logo} className='Deeplink-logo-style' />

      </div>

      <div className='Deeplink-container'>
        <div className='Deeplink-inner-container'>
          <div className='Deeplink-qr-wrapper'>
            <img alt='' src={QRIC} className='Deeplink-qr-img' />
          </div>
          <div className='Deeplink-inner-container-header'>Join using <div className='Deeplink-header-bold'>Rewardstick</div></div>
          <div className='Deeplink-open-btn'
            onClick={openAppStore}><img alt='' src={openIC} className='Deeplink-open-ic' />Open App</div>
          <div className='Deeplink-download-btnapp'
            onClick={() => {
              window.location.href = 'https://play.google.com/store/apps/details?id=com.ecologital.rewardstick_consumer_app'
            }}> <img alt='' src={google} className='Deeplink-download-ic' />Get it on Google Play</div>
          <div className='Deeplink-download-btnapp'
            onClick={() => {
              window.location.href = 'https://apps.apple.com/app/id6751297042'
            }}> <img alt='' src={apple} className='Deeplink-download-ic' />Download on the
            App Store</div>
          <div className='Deeplink-privacy-content'>
            <div>© 2025 Loyalty Scanner Inc. All rights reserved.</div>
            <div className='Deeplink-policy'><span>Privacy Policy</span>
              <span>Terms of Service</span></div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardsTickPageApp;
